import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { NormalizeDecimalSeparatorDirective } from '../../../directives/normalize-decimal-separator.directive';
import { NumericCellEditorBaseComponent } from '../numeric-cell-editor-base/numeric-cell-editor-base.component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-numeric-cell-editor-popup',
    templateUrl: './numeric-cell-editor-popup.component.html',
    styleUrls: ['./numeric-cell-editor-popup.component.scss'],
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TranslateModule,
        FocusSelectOnDirective,
        NormalizeDecimalSeparatorDirective,
    ],
})
export class NumericCellEditorPopupComponent extends NumericCellEditorBaseComponent {
    /**
     * specify the space available for the popup editor
     * passed by NumericCellEditorComponent as cellWidth
     */
    readonly width = input.required<string>();
}
